import styled from "styled-components";

export const StyledLanguages = styled.div`
  height: 100%;

  & .empty-content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .filters {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  & .loader {
    padding-top: 25%;
  }

  & .empty-message-container {
    display: flex;
    justify-content: center;
  }
`;
